import { useMutation } from "@apollo/client/react";
import { REASSESS_INVOICES } from "../../mutations/invoices/reassessInvoices";
import type { InvoiceOperationResult } from "../../../models/InvoiceAssessment";
import GET_CLIENT_ASSESSMENT_INVOICES from "../../queries/invoices/getClientAssessmentInvoices";
import GET_INVOICE_ASSESSMENT_DETAILS from "../../queries/invoices/getInvoiceAssessmentDetails";

export type ReassessInvoicesResult = {
  invoice: { reassessInvoices: InvoiceOperationResult[] };
};

export const useReassessInvoices = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: ReassessInvoicesResult) => void;
  onError: (e?: Error) => void;
}) => {
  const [reassessInvoices, { data, loading, error }] =
    useMutation<ReassessInvoicesResult>(REASSESS_INVOICES, {
      onCompleted,
      onError,
      refetchQueries: [
        GET_CLIENT_ASSESSMENT_INVOICES,
        GET_INVOICE_ASSESSMENT_DETAILS,
      ],
      awaitRefetchQueries: true,
    });

  return { reassessInvoices, data, loading, error };
};
